import React from 'react';
import { isEqual } from 'lodash-es';

import type { IFilterValues } from '@intelligence/v3/filterCore/types';

export const getChangedFields = (prevValues: IFilterValues, nextValues: IFilterValues): string[] => {
  const fields = new Set([...Object.keys(prevValues || {}), ...Object.keys(nextValues || {})]);

  return Array.from(fields).filter((field) => {
    return !isEqual(prevValues[field], nextValues[field]);
  });
};

export const mergeFilterSlotContents = (
  ...contents: Array<React.ReactNode | null | undefined>
): React.ReactNode | null => {
  const nodes = contents.filter((item) => {
    return item !== null && item !== undefined && item !== false;
  });

  if (nodes.length === 0) {
    return null;
  }

  return <>{nodes}</>;
};
